import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as styled from 'styled-components';

export const exposeSharedDependencies = () => {
    if (typeof window !== 'undefined') {
        window.React = React;
        window.ReactDOM = ReactDOM;
        window.styled = styled;
    }
};
